export default __webpack_public_path__ + "static/media/Tutor.5eb27073.png";